/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.25.1
 */

import { TabMenu } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

export const TabMenuStyled = styled(TabMenu)`
    && button {
        min-width: 140px;
        padding: 0 var(--padding-m);
    }
`;

export const NewsFormContainerStyled = styled.div`
    margin: 24px 0;
`;

export const NewsFormDateContainerStyled = styled.div`
    max-width: 260px;
`;

export const NewsFormRepeatContainerStyled = styled.div`
    margin-top: 24px;
    width: fit-content;
    & input {
        max-width: 260px;
    }
`;

export const NewsFormFileContainerStyled = styled.div`
    margin-top: 24px;
`;

export const NewsFormControlsContainerStyled = styled.div`
    width: 100%;
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > :not(:last-child) {
        margin-right: 24px;
    }
`;

export const RequiredHintStyled = styled.div`
    display: flex;
`;

export const ButtonsWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    & > :not(:last-child) {
        margin-right: 24px;
    }
`;

export const ButtonsTooltipWrapperStyled = styled.span`
    display: flex;
    align-items: center;
    & > :not(:last-child) {
        margin-right: 24px;
    }
`;

export const RequiredHintAsteriskStyled = styled.span`
    margin-right: 4px;
    width: 7px;
    height: 24px;
    color: red;
`;
